// extracted by css-extract-rspack-plugin
export default {"severityCritical":"X_Pg8","severityHigh":"HUXbr","severityMedium":"Pr_Ra","severityLow":"sTKS0","severityNeutral":"ly0ru"};